import { Box, Wrap, WrapItem } from "@chakra-ui/react";

interface IRadioProps {
  value: string;
  label: string;
  isActive?: boolean;
  onClick: (value: string) => void;
}

const RadioCard = ({
  value,
  label,
  isActive,
  onClick,
}: IRadioProps): JSX.Element => (
  <Box
    cursor="pointer"
    width="110px"
    borderWidth={2}
    borderStyle="solid"
    data-test={isActive ? `selected.${value}` : value}
    borderColor={isActive ? "ud-primary" : "ud-grey-600"}
    borderRadius="1rem"
    color={isActive ? "ud-primary" : "ud-grey-600"}
    textAlign="center"
    fontWeight="500"
    fontSize="14px"
    py={2}
    _hover={{
      borderColor: !isActive && "ud-grey-400",
      color: !isActive && "ud-grey-400",
    }}
    onClick={() => {
      onClick(value);
    }}
  >
    {label}
  </Box>
);

interface IProps {
  options: Array<{
    value: string;
    label: string;
  }>;
  values: Array<string>;
  dataTest?: string;
  onChange: (value: string) => void;
}

const FormChoice = ({
  options,
  values,
  dataTest,
  onChange,
}: IProps): JSX.Element => (
  <Wrap data-test={dataTest}>
    {options.map((option) => (
      <WrapItem key={option.value}>
        <RadioCard
          value={option.value}
          label={option.label}
          isActive={values.includes(option.value)}
          onClick={onChange}
        />
      </WrapItem>
    ))}
  </Wrap>
);

export default FormChoice;
